import * as _ from 'lodash'
import {WB_ProductConditionRow, WB_ProductConditionTypeRow} from "../PA.Core/PAdbSchemaRows";
import {ConditionContext} from "../PA.Utils/ConditionContext";
import * as AsyncLock from 'async-lock';
import {PeriodService} from "./PeriodService";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {Date_Default_Interval_Length, Period_Type_Definitions} from "../PA.MD.Core/MD.Constants";
import {IwbProductConditionType} from "../PA.Core/PAdbSchemaRowsIF";

export class ConditionService {

    static dctConditionContextCache: {[id:string]: ConditionContext} = {};
    static dctLock: any = new AsyncLock();

    static findCondition(conditionType: WB_ProductConditionTypeRow | IwbProductConditionType,
                         custWbID: number,
                         prdWbID: number,
                         fundType: number,
                         startDt: Date,
                         endDt: Date): Promise<WB_ProductConditionRow> {
        return new Promise<WB_ProductConditionRow>((resolve, error) =>
        {

            ConditionService.getConditionContext(conditionType as WB_ProductConditionTypeRow, custWbID, prdWbID, fundType)
                .then((context) => {
                    context.findSingleCondition(custWbID, prdWbID, fundType, startDt, endDt)
                        .then((cndRecord) => {
                            resolve(cndRecord);
                            return;
                        })
                        .catch((err) => {
                            error(err);
                        })
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    static findConditionsOverDateRange(conditionType: WB_ProductConditionTypeRow | IwbProductConditionType,
                                       custWbID: number,
                                       prdWbID: number,
                                       fundType: number,
                                       startDt: Date,
                                       endDt: Date): Promise<WB_ProductConditionRow[]>
    {
        return new Promise<WB_ProductConditionRow[]>((resolve, error) => {
            ConditionService.getConditionContext(conditionType as WB_ProductConditionTypeRow, custWbID, prdWbID, fundType)
                .then((context) => {
                    context.findConditionsUsingRange(custWbID, prdWbID, fundType, startDt, endDt)
                        .then((cndRecords) => {
                            if (_.isArray(cndRecords)){
                                let retVal = cndRecords as WB_ProductConditionRow[];
                                resolve(retVal);
                                return;
                            }
                            else {
                                resolve([]);
                                return;
                            }
                        })
                        .catch((err) => {
                            error(err);
                        })
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    static findConditionsUsingInterval(conditionType: WB_ProductConditionTypeRow | IwbProductConditionType,
                                       custWbID: number,
                                       prdWbID: number,
                                       fundType: number,
                                       startDt: Date,
                                       intervalCount: number,
                                       intervalLengthinDays?: number): Promise<WB_ProductConditionRow[]>
    {
        return new Promise<WB_ProductConditionRow[]>((resolve, error) => {

            ConditionService.getConditionContext(conditionType as WB_ProductConditionTypeRow, custWbID, prdWbID, fundType)
                .then((context) => {
                    context.findConditionsUsingInterval(custWbID, prdWbID, fundType, startDt, intervalCount, intervalLengthinDays)
                        .then((cndRecords) => {
                            if (_.isArray(cndRecords)){
                              let retVal = cndRecords as WB_ProductConditionRow[];
                              resolve(retVal);
                              return;
                            }
                            else {
                                resolve([]);
                                return;
                            }
                        })
                        .catch((err) => {
                            error(err);
                        });
                })
                .catch((err) => {
                    error(err);
                });
        })
    }

    //given a parent period ID and child period levels, get map of period IDs to condition valid during that period
    static getCndMapByPeriodLevelUsingPeriodWbID(conditionType: WB_ProductConditionTypeRow,
                                                 custWbID: number,
                                                 prdWbID: number,
                                                 fundType: number,
                                                 parentPeriodWbID: number,
                                                 periodTypeWbID: number) : Promise<{ [p: string]: WB_ProductConditionRow }>
    {
        return new Promise<{[periodID: string] : WB_ProductConditionRow}>((resolve, error) => {
            ConditionService.getConditionContext(conditionType, custWbID, prdWbID, fundType)
                .then((context) => {
                    context.getCndMapByPeriodWbIDUsingPeriodWbID(custWbID, prdWbID, fundType, parentPeriodWbID, periodTypeWbID)
                        .then((dctConditionsByPeriod) => {
                            resolve(dctConditionsByPeriod);
                        })
                        .catch((err) => {
                            error(err);
                        });
                })
                .catch((err) => {
                    error(err)
                });
        });
    }

    static getCndMapByPeriodLevelUsingDateRange(conditionType: WB_ProductConditionTypeRow,
                                                custWbID: number,
                                                prdWbID: number,
                                                fundType: number,
                                                effectiveStartDt: Date,
                                                intervalCount: number,
                                                intervalLengthInDays?: number,
                                                periodTypeID?: string) : Promise<{ [p: string]: WB_ProductConditionRow }>
    {
        return new Promise<{[periodID: string]: WB_ProductConditionRow}>((resolve, error) => {
            ConditionService.getConditionContext(conditionType, custWbID, prdWbID, fundType)
                .then((context) => {
                    if (_.isUndefined(intervalLengthInDays)){
                        intervalLengthInDays = Date_Default_Interval_Length;
                    }
                    if (_.isUndefined(periodTypeID)){
                        periodTypeID = Period_Type_Definitions.Week;
                    }
                    let effectiveEndDt: Date = DateUtils.addDays(effectiveStartDt, intervalCount * intervalLengthInDays);
                    context.getCndMapByPeriodWbIDUsingDateRange(custWbID, prdWbID, fundType, effectiveStartDt, effectiveEndDt, periodTypeID)
                        .then((dctConditionsByPeriod) => {
                            resolve(dctConditionsByPeriod);
                        })
                        .catch((err) => {
                            error(err);
                        });
                })
                .catch((err) => {
                    error(err);
                });
        })
    }


    static findConditionsByPeriodWbID(conditionType: WB_ProductConditionTypeRow | IwbProductConditionType,
                                      custWbID: number,
                                      prdWbID: number,
                                      fundType: number,
                                      periodWbID: number) : Promise<WB_ProductConditionRow[]>
    {
        return new Promise<WB_ProductConditionRow[]>((resolve, error) => {
            PeriodService.getPeriodByWBID(periodWbID)
                .then((aPeriod) => {
                    if (!_.isUndefined(aPeriod)){
                        ConditionService.findConditionsOverDateRange(conditionType, custWbID, prdWbID, fundType, DateUtils.convertFromSAPBW(aPeriod.cif.PERIOD_START_DT), DateUtils.convertFromSAPBW(aPeriod.cif.PERIOD_END_DT))
                            .then((results) => {
                                if (_.isArray(results)){
                                    let cndRows = results as WB_ProductConditionRow[];
                                    resolve(cndRows);
                                }
                                else{
                                    resolve([]);
                                }
                            })
                            .catch((err) => {
                                error(err);
                            })
                    }
                })
                .catch((err) => {
                    error(err);
                })
        })
    }

    private static getConditionContext(conditionType: WB_ProductConditionTypeRow,
                                       custWbID: number,
                                       prdWbID: number,
                                       fundType: number)
        : Promise<ConditionContext>
    {
        return new Promise<ConditionContext>((resolve, error) => {

            let dctKey: string = ConditionContext.getContextCacheKey(conditionType, custWbID, prdWbID, fundType);

            ConditionService.dctLock.acquire('global',
                (done: any) => {
                    let context: ConditionContext;

                    if (dctKey in ConditionService.dctConditionContextCache){
                        context = ConditionService.dctConditionContextCache[dctKey];
                    }
                    else {
                        context = new ConditionContext(conditionType, custWbID, prdWbID, fundType);
                        ConditionService.dctConditionContextCache[dctKey] = context;
                    }

                    done(null, ConditionService.dctConditionContextCache[dctKey]);
                    resolve(context);
                })
        });
    }

    static async resetCache(): Promise<void> {
        await ConditionService.dctLock.acquire('global',
            (done: any) => {
                ConditionService.dctConditionContextCache = {}
                done(undefined)
            })
    }

}
